<template>
  <el-dialog :title="$t('PAGE_CLIENTUSER_EMAIL')"
             visible
             width="70%"
             @close="onCancel">

    <el-table height="300px"
              v-loading="loading"
              :data="data"
              border
              @selection-change="handleSelectionChange"
              stripe>
      <el-table-column type="selection"
                       width="50">
      </el-table-column>
      <el-table-column prop="userAccount"
                       :label="$t('COMMON_USER_ACCOUNT')">
      </el-table-column>
      <el-table-column prop="title"
                       :label="$t('TABLE_HEADER_title2')">
      </el-table-column>
      <el-table-column prop="userName"
                       :label="$t('COMMON_USER_NAME')">
      </el-table-column>
      <el-table-column prop="roleList"
                       width="140"
                       :label="$t('TABLE_HEADER_Roles')">
        <template slot-scope="scope">
           <span :title="roleListName(scope.row.roleList)"
                 class="wl-overflow-tooltip">{{(roleListName(scope.row.roleList))}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="emailStatus"
                       :label="$t('TABLE_HEADER_EMAIL_STATUS')">
        <template slot-scope="scope">
          {{scope.row.emailStatus?'sent':'unsent'}}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="wl-pagination"
                   :current-page="pagination.pageNum"
                   :page-size="pagination.pageSize"
                   @current-change="onCurrentPageChange"
                   layout="prev, pager, next,total"
                   :total="pagination.total">

    </el-pagination>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="onCancel"
                 class="wl-grey">{{$t('comment_reSet')}}</el-button>
      <el-button type="primary"
                 :loading="saveLoading"
                 @click="onConfirm"
                 class="wl-green">{{$t('comment_send')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
    import API from '@/api';
    import {mapGetters} from 'vuex';

    export default {
        data() {
            return {
                pagination: {
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                },
                data: [],
                loading: false
            };
        },
        methods: {
            handleSelectionChange(data) {
                this.selectList = data;
            },
            onCurrentPageChange(v) {
                this.pagination.pageNum = v;
                this.getTable();
            },
            getTable() {
                this.loading = true;
                const params = {
                    siteId: this.getSite.siteId,
                    pageNum: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize
                };
                API.clientUser.notifyUser(params).then(res => {
                    if (res.code == '1') {
                        this.data = res.data.records;
                        this.pagination.total = res.data.total;
                        this.loading = false;
                    } else {
                        this.$message.error(this.$t(res.code));
                    }
                });
            },
            onConfirm() {
                if (this.selectList.length > 0) {
                    this.onAdd(this.selectList);
                }
            },
            roleListName(roles) {
                return _.map(roles, v => v.roleName).join('; ')
            }
        },
        computed: {
            ...mapGetters('common', {
                getSite: 'getSite'
            })
        },
        mounted() {
            this.getTable();
        },
        props: {
            onAdd: Function,
            onCancel: Function,
            saveLoading: Boolean
        }
    };
</script>
<style scoped>
  .wl-m-select {
    width: 100%;
  }

  .wl-overflow-tooltip {
    overflow: hidden;
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
